"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PutObjectInput_1 = require("./PutObjectInput");
var PutObjectOutput_1 = require("./PutObjectOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.PutObject = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "PutObject",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}/{Key+}"
    },
    input: {
        shape: PutObjectInput_1.PutObjectInput
    },
    output: {
        shape: PutObjectOutput_1.PutObjectOutput
    },
    errors: []
};
//# sourceMappingURL=PutObject.js.map